import { useState } from 'react';
import { Scanner } from '@yudiel/react-qr-scanner';
import axios from 'axios';

const ScannerModal = ({ show, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState(null); // 'valid' or 'invalid'

  // --- 1. HANDLE SCAN ---
  const handleScan = (results) => {
    if (results && results.length > 0) {
      const rawValue = results[0].rawValue;
      if (rawValue && !loading && !verificationStatus) {
        setLoading(true);
        verifyQR(rawValue);
      }
    }
  };

  // --- 2. VERIFY WITH BACKEND ---
  const verifyQR = async (qrData) => {
    try {
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/api/cards/verify", { qrData });

      if (res.data.success) {
        setVerificationStatus('valid');
      } else {
        setVerificationStatus('invalid');
      }
    } catch (err) {
      setVerificationStatus('invalid');
    } finally {
      setLoading(false);
    }
  };

  const resetScanner = () => {
    setVerificationStatus(null);
    setLoading(false);
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" style={styles.overlay}>
      <div className="modal-content bg-white rounded shadow-lg overflow-hidden" style={styles.modal}>

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <h5 className="mb-0 fw-bold">Scan Patient Card</h5>
          <button onClick={onClose} className="btn-close"></button>
        </div>

        {/* BODY */}
        <div className="p-0 position-relative bg-black" style={{ minHeight: '350px' }}>

          {/* A. CAMERA VIEW (Only show if no result yet) */}
          {!verificationStatus && (
            <div style={{ width: '100%', height: '100%' }}>
              <Scanner
                onScan={handleScan}
                onError={(error) => console.log(error)}
                components={{
                  audio: false, // Mute the beep if you want
                  finder: true  // Shows the little scan square
                }}
                styles={{
                  container: { width: '100%', height: '100%' }
                }}
              />
            </div>
          )}

          {/* B. LOADING STATE */}
          {loading && (
            <div className="position-absolute top-50 start-50 translate-middle text-white text-center" style={{ zIndex: 10 }}>
              <div className="spinner-border mb-2" role="status"></div>
              <p>Verifying Card...</p>
            </div>
          )}

          {/* C. RESULT SCREEN (Success) */}
          {verificationStatus === 'valid' && (
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-success d-flex flex-column justify-content-center align-items-center text-white p-4" style={{ zIndex: 20 }}>
              <i className="bi bi-check-circle-fill" style={{ fontSize: '4rem' }}></i>
              <h3 className="fw-bold mt-3">Verified!</h3>
              <p className="text-center">Card is Active. Apply 50% Discount.</p>
              <button className="btn btn-light text-success fw-bold mt-3" onClick={resetScanner}>Scan Next</button>
            </div>
          )}

          {/* D. RESULT SCREEN (Invalid) */}
          {verificationStatus === 'invalid' && (
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-danger d-flex flex-column justify-content-center align-items-center text-white p-4" style={{ zIndex: 20 }}>
              <i className="bi bi-x-circle-fill" style={{ fontSize: '4rem' }}></i>
              <h3 className="fw-bold mt-3">Declined</h3>
              <p className="text-center">Card Invalid or Expired.</p>
              <button className="btn btn-light text-danger fw-bold mt-3" onClick={resetScanner}>Try Again</button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 1060,
    display: 'flex', justifyContent: 'center', alignItems: 'center'
  },
  modal: {
    width: '90%', maxWidth: '400px'
  }
};

export default ScannerModal;